import { BaseService } from '@/bundles/App/models/BaseService';
import { RecordMapper } from '@/bundles/App/models/RecordMapper';
import {
  IChatSession,
  IChatSessionListResponse,
  IAiMessageListResponse,
} from '@/bundles/AiAgent/types';
import { IGetSessionsDto } from '@/bundles/AiAgent/dto/IGetSessionsDto';
import { IGetMessagesDto } from '@/bundles/AiAgent/dto/IGetMessagesDto';
import { ChatMessageMapper } from '@/bundles/AiAgent/mappers/ChatMessageMapper';

export default class ChatSessionService extends BaseService<IChatSession, RecordMapper<IChatSession>> {
  async createSession (): Promise<IChatSession> {
    try {
      const response = await this.transport.post('/ai-agent/sessions', {});
      return this.recordMapper.mapToModel(response);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getSessions (params: IGetSessionsDto = {}): Promise<IChatSessionListResponse> {
    try {
      const response = await this.transport.get('/ai-agent/sessions', params);

      return {
        ...response,
        sessions: response.sessions.map((session: IChatSession) => this.recordMapper.mapToModel(session)),
      };
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async deleteSession (sessionId: number): Promise<void> {
    try {
      await this.transport.delete(`/ai-agent/sessions/${sessionId}`);
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getSessionMessages (sessionId: number, params: IGetMessagesDto = {}): Promise<IAiMessageListResponse> {
    try {
      const response = await this.transport.get(`/ai-agent/sessions/${sessionId}/messages`, params);

      return {
        ...response,
        messages: ChatMessageMapper.mapToModels(response.messages),
      };
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }
}
